var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 4.25V8.5C8.75 9.20007 8.75 9.5501 8.88624 9.81749C9.00608 10.0527 9.19731 10.2439 9.43251 10.3638C9.6999 10.5 10.0499 10.5 10.75 10.5H19.25C19.9501 10.5 20.3001 10.5 20.5675 10.3638C20.8027 10.2439 20.9939 10.0527 21.1138 9.81749C21.25 9.5501 21.25 9.20007 21.25 8.5V5.5M21.25 26.75V18.75C21.25 18.0499 21.25 17.6999 21.1138 17.4325C20.9939 17.1973 20.8027 17.0061 20.5675 16.8862C20.3001 16.75 19.9501 16.75 19.25 16.75H10.75C10.0499 16.75 9.6999 16.75 9.43251 16.8862C9.19731 17.0061 9.00608 17.1973 8.88624 17.4325C8.75 17.6999 8.75 18.0499 8.75 18.75V26.75M26.25 12.1569V20.75C26.25 22.8502 26.25 23.9003 25.8413 24.7025C25.4817 25.4081 24.9081 25.9817 24.2025 26.3413C23.4003 26.75 22.3502 26.75 20.25 26.75H9.75C7.6498 26.75 6.5997 26.75 5.79754 26.3413C5.09193 25.9817 4.51825 25.4081 4.15873 24.7025C3.75 23.9003 3.75 22.8502 3.75 20.75V10.25C3.75 8.1498 3.75 7.0997 4.15873 6.29754C4.51825 5.59193 5.09193 5.01825 5.79754 4.65873C6.5997 4.25 7.6498 4.25 9.75 4.25H18.3431C18.9546 4.25 19.2604 4.25 19.5481 4.31908C19.8032 4.38032 20.047 4.48133 20.2707 4.6184C20.523 4.773 20.7392 4.98919 21.1716 5.42157L25.0784 9.32843C25.5108 9.76081 25.727 9.977 25.8816 10.2293C26.0187 10.453 26.1197 10.6968 26.1809 10.9519C26.25 11.2396 26.25 11.5454 26.25 12.1569Z",
    stroke: "#747478",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save-icon.d0d46dd4eedfb0caa15323698ba47895.svg";
export { ForwardRef as ReactComponent };